import { render } from "./POSPartsTable.vue?vue&type=template&id=6fd4caec&ts=true"
import script from "./POSPartsTable.vue?vue&type=script&lang=ts"
export * from "./POSPartsTable.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__